import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useContext } from "react";
import grey_x from "Images/checkout/grey_x.svg";
import { useHistory } from "react-router-dom";
import matt from "Images/checkout/rd_matt.png";
import { QuantityIncrementer, BlenderBottle } from "CheckoutComponents";
import Loading from "Components/Loading";
import { Button, IconButton } from "@mui/material";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import styles from "./styles.module.css";
import Price from "./components/Price";
function CartSummary(props) {
    const { checkoutExperience } = useContext(CheckoutContext);
    const history = useHistory();
    const rdLineItem = {
        image_url: matt,
        title: "Matt Mazzino, R.D.",
        product_explanation: "",
        gross_price: "$200.00",
        net_price: "FREE",
        item_type: "",
        delivery_cadence: "",
        // flavor_prefix: null,
        item_key: "rd",
        quantity: null,
        // unit_container_type: null,
        servings: null,
        flavor_attribute_description: "Unlimited access to your personal Registered Dietitian",
        item_category: "",
        available_flavors: [],
        attributes: [],
        bags_info: [],
        flavors: [],
        short_name: "",
        description: "",
        product_id: "",
        max_flavors: 0,
        sku: "",
        container_type: null,
        quantity_description: "",
        checkout_image_url: ""
    };
    const userCartWithRD = props.skipRD ? props.userCart : [...props.userCart, rdLineItem];
    const [cartProducts, setCartProducts] = useState(userCartWithRD);
    const [isBlenderBottle, setIsBlenderBottle] = useState(false);
    const changeFlavor = (item) => {
        if (checkoutExperience === "protein_only") {
            history.push(`/checkout/protein-flavors/#showflavors`);
        }
        else {
            history.push(`/checkout/personalizations#${item?.item_type}`);
        }
    };
    if (props.isStarterKit === true) {
        rdLineItem.gross_price = "FREE";
    }
    useEffect(() => {
        // if price changes due to coupon requiremnts we need display that
        let copyOfProductsDisplayed = [...cartProducts];
        props.userCart.forEach((product) => {
            copyOfProductsDisplayed = copyOfProductsDisplayed.map((_copy_product) => {
                const copy_product = { ..._copy_product }; // decouple instance
                if (product.sku === copy_product.sku) {
                    if (product.net_price !== copy_product.net_price) {
                        copy_product.net_price = product.net_price;
                    }
                }
                return copy_product;
            });
        });
        if (props.userCart.length > 0) {
            setCartProducts(userCartWithRD);
        }
        else {
            setCartProducts(copyOfProductsDisplayed);
        }
    }, [props.userCart]);
    useEffect(() => {
        if (props.updatingFlavors === false && props.updatingPrice === false) {
            // when we go from updating flavors/price to being done, update the cart
            setCartProducts(userCartWithRD);
        }
    }, [props.updatingFlavors, props.updatingPrice]);
    const removeProduct = (itemType, itemTitle, itemIndex) => {
        const cartProductsCopy = [...cartProducts];
        cartProductsCopy[itemIndex].isRemoved = true;
        setCartProducts(cartProductsCopy);
        props.removeFromCart(itemType, itemTitle, itemIndex);
    };
    const addProductToCart = (removedItemName, removedItemIndex) => {
        props.addToCart(removedItemName, removedItemIndex);
        const cartProductsCopy = cartProducts.map((cartProduct, cartProductIndex) => removedItemIndex === cartProductIndex ? { ...cartProduct, isRemoved: false } : cartProduct);
        setCartProducts(cartProductsCopy);
    };
    const changeQuantity = (item_type, increment) => {
        const change = increment ? 1 : -1;
        const cartProductsCopy = cartProducts.map((item) => item.item_type === item_type ? { ...item, quantity: item.quantity + change } : item);
        setCartProducts(cartProductsCopy);
        const new_quantity = cartProductsCopy.find((item) => item.item_type === item_type)?.quantity || 0;
        props.editQuantity(item_type, new_quantity);
        if (checkoutExperience === "protein_only" && item_type === "protein") {
            changeFlavor();
        }
    };
    useEffect(() => {
        if (!isBlenderBottle) {
            setCartProducts(userCartWithRD);
        }
    }, [isBlenderBottle]);
    useEffect(() => {
        const blenderBottle = props.userCart.find((item) => item.item_type === "blenderbottle");
        if (blenderBottle || checkoutExperience === "influencer") {
            setIsBlenderBottle(false);
        }
        else {
            setIsBlenderBottle(true);
        }
    }, [props.userCart]);
    useEffect(() => {
        const blenderBottle = props.userCart.find((item) => item.item_type === "blenderbottle");
        blenderBottle && blenderBottle.item_type && setIsBlenderBottle(false);
    }, []);
    const getCheckoutCartItem = (item, description, index) => {
        if (item.isRemoved) {
            if (item.item_type === "blenderbottle") {
                return null;
            }
            return (_jsxs("div", { className: styles.removeditemblock, children: [_jsx("div", { className: styles.removed_heading, children: `You removed the ${item.title}` }), _jsx("div", { className: styles.removed_text, children: "Would you like to add it back?" }), _jsx("button", { type: "button", className: styles.addback, onClick: () => addProductToCart(props.removedItem.name, index), children: `add ${item.title}` })] }));
        }
        return (_jsxs("div", { className: `${styles.cartrow}  fully-spaced-row`, children: [_jsx("div", { className: `${styles.productimgwrap} ${item.item_key === "rd" && styles.circlepic}`, children: _jsx("img", { alt: "product", className: styles.productimg, src: item.image_url }) }), _jsxs("div", { className: styles.productinfo, children: [_jsxs("div", { className: "fully-spaced-row", children: [_jsx("p", { className: `${styles.bold} ${styles.title}`, children: item.title }), item.item_key !== "rd" && !props.isSimplified && !props.isPaymentOpen && !props.updatingFlavors && (_jsx(IconButton, { "aria-label": "delete", color: "inherit", sx: {
                                        "&.MuiIconButton-root:hover": {
                                            bgcolor: "transparent",
                                        },
                                    }, onClick: () => removeProduct(item.item_type, item.title, index), children: _jsx("img", { alt: "remove", className: styles.grey_x, src: grey_x }) }))] }), item.servings !== null ? (_jsx("div", { children: _jsxs("p", { className: styles.flexgap, children: [_jsx("span", { children: item.product_explanation }), _jsx("span", { children: "|" }), _jsx("span", { children: item.delivery_cadence })] }) })) : (item.item_key !== "rd" &&
                            item.item_key !== "starter-kit" && (_jsx("div", { children: _jsxs("p", { className: styles.flexgap, children: [item.product_explanation && (_jsxs(_Fragment, { children: [_jsx("span", { children: item.product_explanation }), _jsx("span", { children: "|" })] })), _jsx("span", { children: item.delivery_cadence })] }) }))), item.flavor_attribute_description !== null && (_jsx("div", { children: item.item_key !== "rd" ? (description) : (_jsx("p", { className: styles.rdstring, children: item.flavor_attribute_description })) })), props.updatingPrice && item.item_key !== "rd" ? (_jsx("div", { className: styles.loadingLine, children: _jsx(Loading, { isLine: true }) })) : (_jsx(Price, { gross: item.gross_price, nett: item.net_price })), ((item.item_type === "hydration" && !props.isSimplified && checkoutExperience === "hydration_only") ||
                            (item.item_type === "protein" && props.isSimplified && checkoutExperience === "protein_only")) &&
                            !props.isStarterKit && (_jsx("div", { className: styles.quantity_container, children: _jsx(QuantityIncrementer, { quantity: item.quantity, maxQuantity: 2, minQuantity: 1, changeQuantity: changeQuantity, item_type: item.item_type }) }))] })] }));
    };
    return (_jsxs(_Fragment, { children: [cartProducts.map((item, index) => {
                let description = _jsx(_Fragment, {});
                if (props.isSimplified) {
                    description = (_jsx("div", { className: `${styles.flavorstring} ${props.updatingFlavors ? styles.hiddenflavorstring : ""} ${props.flavorButtons ? styles.nodecorate : ""}`, children: Array.isArray(item.flavor_attribute_description)
                            ? item.flavor_attribute_description.map((line) => _jsx("p", { children: line }, line))
                            : item.flavor_attribute_description }));
                }
                else if (props.updatingFlavors && ["protein", "preworkout", "hydration"].indexOf(item.item_type) >= 0) {
                    description = (_jsx("div", { className: styles.loadingLine, children: _jsx(Loading, { isLine: true }) }));
                }
                else {
                    description = (_jsx(Button, { sx: {
                            maxWidth: 250,
                            fontFamily: "Halyard",
                            fontSize: 16,
                            fontWeight: 500,
                            lineHeight: 1.13,
                            textTransform: "none",
                            padding: 0,
                            textAlign: "left",
                            color: "#333",
                            textDecoration: "underline",
                            m: 0,
                            "&.MuiButton-root:hover": {
                                bgcolor: "transparent",
                                textDecoration: "underline",
                            },
                        }, className: `${styles.flavorstring} ${styles.flavorstring_link}`, onClick: () => changeFlavor(item), children: item.flavor_attribute_description }));
                }
                return _jsx(React.Fragment, { children: getCheckoutCartItem(item, description, index) }, item.title);
            }), isBlenderBottle && _jsx(BlenderBottle, {})] }));
}
export default CartSummary;
